import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import moment from 'moment';
import _ from 'lodash';
import { Part, PartType } from 'app/core/model/entity-model';

@Component({
    selector: 'app-part-type-select-dialog',
    templateUrl: './part-type-select-dialog.component.html',
    styleUrls: ['./part-type-select-dialog.component.scss'],
    standalone: false
})
export class PartTypeSelectDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    excludePartTypeIds: any[];
    partTypes: any[];
    entity = { partTypeId: null }

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, private modalService: BsModalService) { }

    async ngOnInit() {
        const partTypes = (await this.uow.partTypes.whereActive()) as PartType[];
        if (!this.excludePartTypeIds)
            this.partTypes = partTypes;
        else
            this.partTypes = partTypes.filter(partType => !this.excludePartTypeIds.includes(partType.id));
    }

    async save() {
        this.result.next({ success: true, partTypeId: this.entity.partTypeId });
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }
}
